<template>
    <div>
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" version="1.1" id="svg1"
            sodipodi:docname="submit.svg" inkscape:version="1.3.2 (091e20e, 2023-11-25, custom)"
            xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
            xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd" xmlns="http://www.w3.org/2000/svg"
            xmlns:svg="http://www.w3.org/2000/svg">
            <defs id="defs1" />
            <path
                d="m 9,14 h 2 V 9.8 L 12.6,11.4 14,10 10,6 6,10 7.4,11.4 9,9.8 Z m 1,6 C 8.6167,20 7.31667,19.7375 6.1,19.2125 4.88333,18.6875 3.825,17.975 2.925,17.075 2.025,16.175 1.3125,15.1167 0.7875,13.9 0.2625,12.6833 0,11.3833 0,10 0,8.6167 0.2625,7.31667 0.7875,6.1 1.3125,4.88333 2.025,3.825 2.925,2.925 3.825,2.025 4.88333,1.3125 6.1,0.7875 7.31667,0.2625 8.6167,0 10,0 c 1.3833,0 2.6833,0.2625 3.9,0.7875 1.2167,0.525 2.275,1.2375 3.175,2.1375 0.9,0.9 1.6125,1.95833 2.1375,3.175 C 19.7375,7.31667 20,8.6167 20,10 c 0,1.3833 -0.2625,2.6833 -0.7875,3.9 -0.525,1.2167 -1.2375,2.275 -2.1375,3.175 -0.9,0.9 -1.9583,1.6125 -3.175,2.1375 C 12.6833,19.7375 11.3833,20 10,20 Z"
                fill="#ffffff" id="path1" :class="getClass()" />
        </svg>

    </div>
</template>

<script lang="ts">
import {
    Component, Prop, Vue
} from 'vue-property-decorator';

@Component
export default class VehicleTrimBotSubmitComponent extends Vue {
    @Prop({ default: false })
    private buttonDisabled!: boolean;

    private getClass(): string {
        if (this.buttonDisabled) {
            return 'trim-bot-submit-button-disabled';
        }
        return 'trim-bot-submit-button';
    }
}
</script>
